export enum RegistryType {
  Actor = 'actor_registry',
  Animations = 'animations_registry',
  AnimationsMetaInfo = 'animations_meta_info_registry',
  Audio = 'audio_registry',
  AudioListeners = 'audio_listeners_registry',
  AudioMetaInfo = 'audio_meta_info_registry',
  AudioRaw = 'audio_raw_registry',
  Camera = 'camera_registry',
  Controls = 'controls_registry',
  EnvMap = 'env_map_registry',
  EnvMapMetaInfo = 'env_map_meta_info_registry',
  EnvMapTexture = 'env_map_texture_registry',
  Fog = 'fog_registry',
  FsmInstance = 'fsm_instance_registry',
  FsmSource = 'fsm_source_registry',
  IntersectionsWatcher = 'intersections_watcher_registry',
  KeyWatcher = 'key_watcher_registry',
  Light = 'light_registry',
  LoadingManager = 'loading_manager_registry',
  Loop = 'loop_registry',
  Material = 'material_registry',
  Model3d = 'model_3d_registry',
  Model3dMetaInfo = 'model_3d_meta_info_registry',
  Model3dRaw = 'model_3d_raw_registry',
  Models3dRawToModels3dToConnection = 'models_3d_raw_to_models_3d_connection_registry',
  Models3dToActorConnection = 'models_3d_to_actor_connection_registry',
  MouseClickWatcher = 'mouse_click_watcher_registry',
  MousePositionWatcher = 'mouse_position_watcher_registry',
  Particles = 'particles_registry',
  PhysicsBody = 'physics_body_registry',
  Renderer = 'renderer_registry',
  Scene = 'scene_registry',
  Space = 'space_registry',
  SpatialGrid = 'spatial_grid_registry',
  Text2d = 'text_2d_registry',
  Text3d = 'text_3d_registry',
  Text3dTexture = 'text_3d_texture_registry',
  TextRenderer = 'text_renderer_registry',
  Texture = 'texture_registry',
  TextureMetaInfo = 'texture_meta_info_registry',
  TransformDrive = 'transform_drive_registry'
}
